<template>
  <div class="timu">
    <img src="@/assets/4/bg.jpg" class="bg" />
    <img src="@/assets/4/img1.png" class="img1" />
    <div class="img3">
      <img src="@/assets/4/img3.png" />
    </div>

    <!-- 题目1 -->
    <div class="ask ask1" v-if="askShow == 1">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask1-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask1(1)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN != 1" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN == 1" />
          <img src="@/assets/4/ask1-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask1(2)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN != 2" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN == 2" />

          <img src="@/assets/4/ask1-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask1(3)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN != 3" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN == 3" />

          <img src="@/assets/4/ask1-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask1(4)"
        >
          <img src="@/assets/4/green.png" class="ask-bg" v-if="askN !=''" />
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-else />

          <img src="@/assets/4/ask1-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 题目2 -->
    <div class="ask ask2" v-if="askShow == 2">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask2-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask2(1)"
        >
          <img src="@/assets/4/green2.png" class="ask-bg" v-if="askN2!=''" />
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-else />
          <img src="@/assets/4/ask2-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask2(2)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN2 != 2" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN2 == 2" />

          <img src="@/assets/4/ask2-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask2(3)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN2 != 3" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN2 == 3" />
          <img src="@/assets/4/ask2-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask2(4)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN2 != 4" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN2 == 4" />

          <img src="@/assets/4/ask2-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 题目3 -->
    <div class="ask ask3" v-if="askShow == 3">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask3-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask3(1)"
        >
          <img src="@/assets/4/green2.png" class="ask-bg" v-if="askN3!=''" />
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-else />
          <img src="@/assets/4/ask3-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask3(2)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN3 != 2" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN3 == 2" />

          <img src="@/assets/4/ask3-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask3(3)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN3 != 3" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN3 == 3" />
          <img src="@/assets/4/ask3-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask3(4)"
        >
          <img src="@/assets/4/ask2-bg.png" class="ask-bg" v-if="askN3 != 4" />
          <img src="@/assets/4/red2.png" class="ask-bg" v-if="askN3 == 4" />

          <img src="@/assets/4/ask3-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 题目4 -->
    <div class="ask ask4" v-if="askShow == 4">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask4-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask4(1)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN4 != 1" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN4 == 1" />
          <img src="@/assets/4/ask4-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask4(2)"
        >
          <img src="@/assets/4/green.png" class="ask-bg" v-if="askN4 != ''" />
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-else />

          <img src="@/assets/4/ask4-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask4(3)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN4 != 3" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN4 == 3" />
          <img src="@/assets/4/ask4-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask4(4)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN4 != 4" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN4 == 4" />
          <img src="@/assets/4/ask4-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 题目5 -->
    <div class="ask ask5" v-if="askShow == 5">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask5-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask5(1)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN5 != 1" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN5 == 1" />
          <img src="@/assets/4/ask5-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask5(2)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN5 != 2" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN5 == 2" />

          <img src="@/assets/4/ask5-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask5(3)"
        >
          <img src="@/assets/4/green.png" class="ask-bg" v-if="askN5!=''" />
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-else />
          <img src="@/assets/4/ask5-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask5(4)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN5 != 4" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN5 == 4" />

          <img src="@/assets/4/ask5-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 题目6 -->
    <div class="ask ask6" v-if="askShow == 6">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/ask6-tit.png" class="tit-bg" />
      </div>
      <div class="ask-info">
        <div
          class="info1"
          :class="{ 'animated zoomIn': active }"
          @click="ask6(1)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN6 != 1" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN6 == 1" />
          <img src="@/assets/4/ask6-info1.png" class="info-bg" />
        </div>
        <div
          class="info2"
          :class="{ 'animated zoomIn': active }"
          @click="ask6(2)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN6 != 2" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN6 == 2" />

          <img src="@/assets/4/ask6-info2.png" class="info-bg" />
        </div>
        <div
          class="info3"
          :class="{ 'animated zoomIn': active }"
          @click="ask6(3)"
        >
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-if="askN6 != 3" />
          <img src="@/assets/4/red.png" class="ask-bg" v-if="askN6 == 3" />
          <img src="@/assets/4/ask6-info3.png" class="info-bg" />
        </div>
        <div
          class="info4"
          :class="{ 'animated zoomIn': active }"
          @click="ask6(4)"
        >
          <img src="@/assets/4/green.png" class="ask-bg" v-if="askN6!=''" />
          <img src="@/assets/4/ask1-bg.png" class="ask-bg" v-else />
          <img src="@/assets/4/ask6-info4.png" class="info-bg" />
        </div>
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 连线 -->
     <div class="ask ask7" v-if="askShow == 7">
      <div class="ask-img4">
        <img src="@/assets/4/img4.png" class="img4" />
      </div>
      <div class="ask-tit">
        <img src="@/assets/4/xian-tit.png" class="tit-bg animated rollIn" />
      </div>
      <div class="ask-info">
        <img src="@/assets/4/xian.png" class="tit-bg animated lightSpeedIn" />
      </div>
      <!-- 旋转 -->
      <img src="@/assets/4/rotate.png" class="rotate" />
    </div>
    <!-- 回答正确 -->
    <img src="@/assets/4/success.png" class="success" v-if="ask1Status == 1" />
    <!-- 回答错误 -->
    <img src="@/assets/4/error.png" class="error" v-if="ask1Status == 2" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      askShow: 1,
      askN: "",
      askN2: "",
      askN3: "",
      askN4: "",
      askN5: "",
      askN6: "",
      ask1Status: 0,
      active: true,
    };
  },
  methods: {
    ask1(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN = n;
      if (n == 4) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
      setTimeout(() => {
        this.askShow = 2;
        this.askShow3 = 1;
        this.ask1Status = 0;
        this.active = true;
      }, 1000);
    },
    ask2(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN2 = n;
      if (n == 1) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
      setTimeout(() => {
        this.askShow = 3;
        this.ask1Status = 0;
        this.active = true;
      }, 1000);
    },
    ask3(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN3 = n;
      if (n == 1) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
      setTimeout(() => {
        this.askShow = 4;
        this.ask1Status = 0;
        this.active = true;
      }, 1000);
    },
    ask4(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN4 = n;
      if (n == 2) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
      setTimeout(() => {
        this.askShow = 5;
        this.ask1Status = 0;
        this.active = true;
      }, 1000);
    },
    ask5(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN5 = n;
      if (n == 3) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
      setTimeout(() => {
        this.askShow = 6;
        this.ask1Status = 0;
        this.active = true;
      }, 1000);
    },
    ask6(n) {
      this.$nextTick(() => {
        this.active = false;
      });
      this.askN6 = n;
      if (n == 4) {
        this.ask1Status = 1;
      } else {
        this.ask1Status = 2;
      }
     setTimeout(() => {
        this.askShow = 7;
        this.ask1Status = 0
      }, 1000);
       setTimeout(() => {
        this.$router.push('/change')
      }, 4000);
    },
  },
};
</script>
<style scoped>
/* .timu {
  position: relative;
  width: 100%;
  height: 100%;
} */
.bg {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.ask {
  width: 84%;
  position: absolute;
  top: 29vw;
  left: 8%;
  padding-bottom: 10vw;
}
.ask-img4 {
  position: absolute;
  /* z-index: -1; */
}
.ask-img4 img {
  width: 100%;
}
.tit-bg {
  width: 100%;
}
.ask-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
}
.ask .ask-info div {
  width: 44%;
  position: relative;
  padding: 3%;
}
.ask2 .ask-info div {
  width: 95%;
  position: relative;
  padding: 0;
}
.ask3 .ask-info div {
  width: 95%;
  position: relative;
  padding: 0;
}
.ask-info div .ask-bg {
  /* position: absolute; */
  width: 100%;
}
.ask-info div .info-bg {
  position: absolute;
  width: 72%;
  left: 15%;
  top: 6vw;
}
.ask2 .ask-info div .info-bg {
  width: 56%;
  top: 3vw;
  left: 5vw;
}
.ask3 .ask-info div .info-bg {
  width: 70%;
  top: 3vw;
  left: 5vw;
}
.ask4 .ask-info div .info-bg {
  width: 44%;
  top: 5.5vw;
  left: 30%;
}
.ask6 .ask-info div .info-bg {
  width: 43%;
  left: 28%;
  top: 5.5vw;
}
.ask1 .ask-info div:nth-child(1) .info-bg {
  width: 50%;
}
.ask1 .ask-info div:nth-child(2) .info-bg {
  width: 58%;
}
.ask2 .ask-info div:nth-child(2) .info-bg {
  width: 70%;
}
.ask2 .ask-info div:nth-child(4) .info-bg {
  width: 75%;
}
.ask3 .ask-info div:nth-child(2) .info-bg {
  width: 35%;
}
.ask3 .ask-info div:nth-child(3) .info-bg {
  width: 28%;
}
.ask3 .ask-info div:nth-child(4) .info-bg {
  width: 35%;
}
.ask4 .ask-info div:nth-child(1) .info-bg {
  width: 39%;
}
.ask5 .ask-info div:nth-child(1) .info-bg {
  width: 52%;
  left: 24%;
}
.ask5 .ask-info div:nth-child(3) .info-bg {
  width: 58%;
  left: 21%;
}
.ask5 .ask-info div:nth-child(4) .info-bg {
  width: 50%;
  left: 25%;
}
.ask6 .ask-info div:nth-child(1) .info-bg {
  width: 52%;
  left: 24%;
}
.ask-tit {
  width: 78%;
  margin: 0 auto;
  position: relative;
  top: 4vw;
  margin-bottom: 12vw;
}
.ask2 .ask-tit {
  margin-bottom: 11vw;
  width: 74%;
}
.ask3 .ask-tit {
  margin-bottom: 11vw;
}
.ask4 .ask-tit {
  width: 49%;
  top: 4vw;
}
.ask5 .ask-tit {
  width: 67%;
  top: 3vw;
}
.ask6 .ask-tit {
  width: 51%;
}
.ask7 .ask-tit {
  width: 43%;
}
.rotate {
  width: 10vw;
  position: absolute;
  animation: rotate 10s linear infinite;
  -webkit-animation: rotate 10s linear infinite;
  bottom: 9vw;
  left: 5vw;
}
/* 旋转 */
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }

  25% {
    -webkit-transform: rotate(90deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  75% {
    -webkit-transform: rotate(270deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
.success,
.error {
  position: absolute;
  width: 50%;
  left: 25%;
  bottom: 6%;
}
.info2 {
  animation-delay: 1s;
  -webkit-animation-delay: 1s; /* Safari 和 Chrome */
}
.info3 {
  animation-delay: 2s;
  -webkit-animation-delay: 2s; /* Safari 和 Chrome */
}
.info4 {
  animation-delay: 3s;
  -webkit-animation-delay: 3s; /* Safari 和 Chrome */
}
.img1 {
  position: absolute;
  width: 24vw;
  top: -7vw;
  left: 2vw;
}
.img3 {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: -8%;
}
.img3 img {
  width: 109%;
}
</style>


// WEBPACK FOOTER //
// src/pages/timu/timu.vue